<template>
  <div id="SideBar" :class="{ show: show }">
    <div v-if="isLoading" class="spinner-container">
      <b-spinner></b-spinner>
    </div>
    <div v-else class="sideBarInner" :class="{ showInner: show }">
      <div class="top">
        <div
          class="option"
          @click="selectedOption = 0"
          :class="{ selected: selectedOption === 0 }"
        >
          {{ showReminders ? "Unread" : "Upcoming" }}
        </div>
        <div
          class="option"
          @click="selectedOption = 1"
          :class="{ selected: selectedOption === 1 }"
        >
          {{ showReminders ? "Read" : "Past" }}
        </div>
      </div>
      <div v-if="showAppointments" class="appointments-list">
        <div v-if="appointmentsToDisplay.length === 0" class="noAppts">
          You have no appointments to view
        </div>
        <AppointmentCard
          v-for="(appt, i) in appointmentsToDisplay"
          :key="i"
          :item="appt"
          :upcoming="selectedOption === 0"
        />
      </div>
      <div v-else class="notifications-list">
        <div v-if="!notificationsToDisplay.length" class="noAppts">
          There are no notifications to view
        </div>
        <Notification
          v-for="(notification, i) in notificationsToDisplay"
          :key="i"
          :notification="notification"
        />
      </div>
    </div>
  </div>
</template>
<script>
import moment from "moment";
import AppointmentCard from "./AppointmentCard.vue";
import EventBus from "../helpers/eventbus";
import Notification from "./Notification.vue";
export default {
  components: {
    Notification,
    AppointmentCard
  },
  props: ["showReminders", "showAppointments"],
  data() {
    return {
      nav_height: 0,
      selectedOption: 0,
      readNotifications: [],
      unreadNotifications: [],
      isLoading: false,
      appointments: [],
      upcomingAppointments: [],
      pastAppointments: []
    };
  },
  mounted() {
    this.getAppointments();
    this.getReminders();
    EventBus.$on("getReminders", this.getReminders);
    EventBus.$on("getAppointments", this.getAppointments);
  },
  computed: {
    show() {
      return this.showReminders || this.showAppointments;
    },
    appointmentsToDisplay() {
      return this.selectedOption === 0
        ? this.upcomingAppointments
        : this.pastAppointments;
    },
    notificationsToDisplay() {
      return this.selectedOption === 0
        ? this.unreadNotifications
        : this.readNotifications;
    }
  },
  methods: {
    async getReminders() {
      try {
        if (this.isLoading) return;
        this.isLoading = true;
        const res = await this.api({
          path: "api/u/notifications"
        });
        this.reminders = res.data;
        this.readNotifications = this.reminders.filter(notification => {
          return notification && notification.readAt;
        });
        this.unreadNotifications = this.reminders.filter(notification => {
          return notification && !notification.readAt;
        });
      } catch (err) {
        console.error(err);
      } finally {
        this.isLoading = false;
      }
    },
    async getAppointments() {
      try {
        if (this.isLoading) return;
        this.isLoading = true;
        const res = await this.api({
          path: "api/u/dmh/get-appointments"
        });
        this.appointments = res?.appointments;
        const now = moment();
        this.pastAppointments = this.appointments
          .filter(booking => {
            const start = moment(booking.startTime);
            return now.diff(start, 'minutes') > 15
          })
          .sort((a, b) => moment(b.startTime).valueOf() - moment(a.startTime).valueOf());
        this.upcomingAppointments = this.appointments.filter(booking => {
          const start = moment(booking.startTime);
          return now.diff(start, 'minutes') <= 15 && booking?.appointmentStatus !== "Cancelled";
        });
      } catch (err) {
        console.error(err);
      } finally {
        this.isLoading = false;
      }
    }
  }
};
</script>
<style lang="less">
#SideBar {
  position: absolute;
  right: 0;
  width: 0;
  height: 100%;
  z-index: 400;
  transition: width 0.25s ease-in;
  background-color: #f9f9f9;

  .appointments-list {
    height: 100%;
    max-height: 100%;
    padding: 24px 16px 80px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    gap: 20px;
    overflow: scroll;
  }

  .notifications-list {
    height: auto;
    overflow: scroll;
    padding: 24px 16px 80px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    gap: 20px;
  }

  .spinner-container {
    color: #000;
    padding: 20px;
    display: flex;
    justify-content: center;
  }
  .sideBarInner {
    opacity: 0;
    display: flex;
    flex-direction: column;
    transition: none;
    height: 100%;
    max-height: 100%;
    &.showInner {
      transition: opacity 0.35s ease-in 0.25s;
      opacity: 1;
    }
  }
  .noAppts {
    color: #333333;
    font-size: 1.5rem;
  }
  &.show {
    max-width: 400px;
    width: 100%;
  }
  .top {
    background-color: #fff;
    display: grid;
    grid-template-columns: 1fr 1fr;
    .option {
      display: flex;
      align-items: center;
      justify-content: center;
      text-align: center;
      height: 73px;
      font-size: 1.4rem;
      color: #403d56;
      cursor: pointer;
      border-bottom: #d9d9d9 2px solid;
      &.selected {
        border-bottom: var(--brand-primary) 2px solid;
        color: var(--brand-primary);
        font-family: FilsonProBold, Arial, Helvetica, sans-serif;
      }
    }
  }
}
</style>
